import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import LoginRedirectPage from './LoginRedirectPage';

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/login/:token" element={<LoginRedirectPage />} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);
